module.exports = __webpack_public_path__ + "img/profile_credential_017.b49c6d97.png";